import axios from 'axios';
import { authInterceptor, logout } from './auth-interceptor';

const voiceAgentService = import.meta.env.VITE_VOICE_AGENT_URL;

export const voiceAgentHttp = axios.create({
  baseURL: `${voiceAgentService}/api/v1`,
  withCredentials: true,
});

voiceAgentHttp.interceptors.response.use((result) => result.data);

// A raw 401 from the coordinator service must NOT log the user out. The
// coordinator can be unreachable or reject auth independently of the user's
// app session (notably it isn't running in local dev), so only explicit
// account-state errors force a logout. An expired token is refreshed and the
// request retried silently (see `shouldRefresh`); any other failure —
// including a bare 401 — is surfaced to the caller as an error payload by the
// shared interceptor's 4xx branch instead of ending the session.
export const shouldLogout = (error) => {
  const errorCode = error?.response?.data?.error;
  return ['err_user_deleted', 'err_suspended'].includes(errorCode);
};

export const shouldRefresh = (error) =>
  error?.response?.data?.error === 'err_token_expired';

authInterceptor(voiceAgentHttp, {
  getAccessToken: () => localStorage.getItem('apiv1Auth'),
  shouldLogout,
  shouldRefresh,
  logout,
});
